import { axiosInstance } from "@/utils/lib/axios";
import { QueryFunctionContext, useQuery } from "@tanstack/react-query";
import { RFSData } from "./rfs";
import { DataConfig } from "@/components/table/useDefaultDataConfig";

interface GenerateABDFDTData {
  id: string;
  fdtId: string;
  poleId: string;
  coordinateLat: string;
  coordinateLong: string;
  poleProvider: string;
  poleType: string;
  generateAbdPole: {
    id: string;
    poleId: string;
    coordinateLat: string;
    coordinateLong: string;
    poleProvider: string;
    poleType: string;
    rfs: RFSData;
  };
  rfs: RFSData;
}

/* ===================== *
 * READ generate ABD FDT *
 * ===================== */

type GenerateABDFDTsQueryKey = DataConfig & {
  rfsId?: string;
};

async function getGenerateABDFDTs(
  queryFunctionContext: QueryFunctionContext,
): Promise<GenerateABDFDTData[]> {
  const { queryKey } = queryFunctionContext;
  const [_, generateABDFDTQueryKey] = queryKey;
  const { rfsId } = generateABDFDTQueryKey as GenerateABDFDTsQueryKey;

  const response = await axiosInstance.get(
    `/api/crud/generate-abd-fdt?rfs.id=${rfsId ?? ""}`,
  );
  return response.data.data.content;
}
function useGenerateABDFDTs(
  generateABDFDTQueryKey: GenerateABDFDTsQueryKey = {},
  options?: {
    enabled?: boolean;
    staleTime?: number;
  },
) {
  const { rfsId } = generateABDFDTQueryKey;
  return useQuery({
    ...options,
    queryKey: ["generateABDFDTs", { rfsId }],
    queryFn: getGenerateABDFDTs,
  });
}

async function getGenerateABDFDTsCount(
  queryFunctionContext: QueryFunctionContext,
): Promise<number> {
  const { queryKey } = queryFunctionContext;
  const [_, generateABDFDTQueryKey] = queryKey;
  const { rfsId } = generateABDFDTQueryKey as GenerateABDFDTsQueryKey;

  const response = await axiosInstance.get(
    `/api/crud/generate-abd-fdt/count?rfs.id=${rfsId ?? ""}`,
  );
  return response.data.data;
}
function useGenerateABDFDTsCount(
  generateABDFDTQueryKey: GenerateABDFDTsQueryKey = {},
  options?: {
    enabled?: boolean;
    staleTime?: number;
  },
) {
  const { rfsId } = generateABDFDTQueryKey;
  return useQuery({
    ...options,
    queryKey: ["generateABDFDTsCount", { rfsId }],
    queryFn: getGenerateABDFDTsCount,
  });
}

export type { GenerateABDFDTData };
export { useGenerateABDFDTs, useGenerateABDFDTsCount };
